import React from 'react'
import { useContext, useEffect } from 'react'
import { AppContext } from '../../../services/Appcontext'
import Pagetemplate from '../../templates/Pagetemplate'

const buttonLabels = ['سمير غانم', 'label 2', 'label 3', 'label 4', 'label 5', 'label 6', 'label 7', 'label 8', 'label 9'];

const title1="الأدب"
const title2="الإقتصاد"
const title3 = "العلوم"
const title=[title1,title2,title3]

export default function Fieldspage() {
  const {mostSearched, getMostSearched,
          charByField, getCharByField,
          getmostChar, mostChar,
          searchQuery,
          fieldId,
          specialityId,
        } = useContext(AppContext)

  useEffect(() => {
    // getMostSearched(9)
    console.log("############3")
    getmostChar()
    getCharByField(searchQuery,fieldId,specialityId)
  },[searchQuery,fieldId,specialityId])

// console.log("data of the المجلات",mostSearched.data, charByField.data)
// console.log("data of the المجلات",charByField.data)
// console.log("data of the المجلات",mostChar.data)
// console.log("data of the المجلات", searchQuery)
// console.log("mostChar of the المجلات", mostChar)

  return (
    <div>
      <Pagetemplate 
          title={title} 
          introdata={mostChar.data} 
          contentData={charByField.data}
          defaultChecked="fields"
          ></Pagetemplate>
    </div>
  )
}
